import React, {type FC} from 'react';
import s from './ProductMediaDots.scss';
import classNames from 'classnames';
import {useProductGallery} from '../../ProductGalleryProvider/ProductGalleryProvider';
import type {IMediaItem} from '../../../../types/app-types';

export enum ProductMediaDotsDataHooks {
  Root = 'product-media-dots-root',
  Dot = 'product-media-dot',
}

export interface ProductMediaDotsProps {
  media: IMediaItem[];
}

export const ProductMediaDots: FC<ProductMediaDotsProps> = ({media}) => {
  const {selectedIndex, changeSelectedIndex} = useProductGallery();
  return (
    <div className={s.root} data-hook={ProductMediaDotsDataHooks.Root}>
      {media.map((_, index) => {
        const isSelected = selectedIndex === index;
        return (
          <button
            type="button"
            key={index}
            className={classNames(s.dot, {[s.isSelected]: isSelected})}
            data-hook={ProductMediaDotsDataHooks.Dot}
            onClick={() => changeSelectedIndex(index)}
            aria-pressed={isSelected}
          />
        );
      })}
    </div>
  );
};
